import React from 'react';
import './HeaderComponent.scss'
const CustomHeader = () => {
  return (
    <div className='header-container'>
      <img src="https://naur.ai/json/image_customer.png" alt="Chatbot logo"/>
      <p className='greeting-text'>Ask Ana: <br/>We're Here to Help!</p>
    </div>
  );
};
export default CustomHeader;